import { Box, Button, Fab, useMediaQuery, useTheme } from "@mui/material";
import { useRouter } from "@/Router/router";
import List from "@/Components/List/List";
import { ContentWrapper } from "vig-ui-library";
import { IoIosAdd, IoMdAddCircleOutline } from "react-icons/io";

export const Requests = () => {
    const theme = useTheme();

    const { navigateToRequestCatalog } = useRouter();

    const onlySmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <ContentWrapper sx={{ display: "flex", flexDirection: "column" }}>
            {!onlySmallScreen && <RequestsToolbar />}

            <Box sx={{ overflowY: "auto", flexGrow: 1, paddingBottom: onlySmallScreen ? 6 : 0 }}>
                <List />
            </Box>

            {onlySmallScreen && (
                <Fab
                    sx={{ position: "absolute", bottom: theme.spacing(4), right: theme.spacing(3) }}
                    onClick={() => navigateToRequestCatalog()}
                >
                    <IoIosAdd size={24} />
                </Fab>
            )}
        </ContentWrapper>
    );
}

const RequestsToolbar = () => {
    const { navigateToRequestCatalog } = useRouter();

    return (
        <Box sx={{ borderBottom: 1, borderColor: "divider", paddingX: 2, paddingY: 1, flexShrink: 0 }}>
            <Button onClick={() => navigateToRequestCatalog()} startIcon={<IoMdAddCircleOutline />}>
                Pridať novú žiadosť
            </Button>
        </Box>
    );
};